import { Module } from 'vuex'

import { ReceiptState, RootState } from '@/types/store'
import { generateItem } from '@/utils/generator'
import moment from 'moment'

import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const summary = {
  thisMonth: -1,
  lastMonth: -1,
  today: -1,
  yesterday: -1,
  now: -1,
  thisMonthFirst: -1,
  lastMonthFirst: -1,
  todayFirst: -1,
  yesterdayFirst: -1,
}

const state: ReceiptState = {
  receiptType: 'unchecked',
  receipt: null,
  receipts: [],
  total: -1,
  searchCondition: {
    supplier: null,
    monitorId: null,
    receiptId: null,
    contributedAtStart: moment()
      .subtract(1, 'day')
      .format('YYYY-MM-DD'),
    contributedAtEnd: moment().format('YYYY-MM-DD'),
    gender: null,
    prefecture: null,
    age: null,
    chainStoreName: null,
    purchasedAtStart: null,
    purchasedAtEnd: null,
    ngReason: null,
  },
  masterSearchItem: {
    item: generateItem(),
    index: -1,
  },
  isReceiptsLoading: false,
  isSummariesLoading: false,
  summaries: {
    contributerUU: { ...summary },
    inComing: { ...summary },
    duplicated: { ...summary },
    system: {
      ok: { ...summary },
      autoCompleted: { ...summary },
      noPhone: { ...summary },
      noShop: { ...summary },
      invalidChainStore: { ...summary },
      noDateTime: { ...summary },
      invalidDateTime: { ...summary },
      noTargetCategoryItem: { ...summary },
    },
    leaderForSystemNg: {
      incompleted: { ...summary },
      shopApplying: { ...summary },
      ok: { ...summary },
      ng: { ...summary },
    },
    linker: {
      incompleted: { ...summary },
      wip: { ...summary },
      ok: { ...summary },
      ng: { ...summary },
    },
    leaderForLinkerNg: {
      incompleted: { ...summary },
      ok: { ...summary },
      ng: { ...summary },
    },
    completed: { ...summary },
    completedItem: { ...summary },
    autocompletedItem: { ...summary },
    newItem: { ...summary },
    reItem: { ...summary },
    linkerUU: { ...summary },
    leaderUU: { ...summary },
  },
}

export const receipt: Module<ReceiptState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
